import { CommonModule, LocationStrategy } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild,
  inject,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { IonContent, ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  BetbuilderComponent,
  SbDropdownComponent,
  SbGridHeaderComponent,
  SbLiveScoreboardBaseballComponent,
  SbLiveScoreboardRegularComponent,
  SbLiveScoreboardSetsComponent,
  SbMarqueeBetSenseComponent,
  SbTabsCategoriesComponent,
  SportsBetButtonComponent,
  SportsBetButtonWrapperColumnComponent,
  SportsGridComponent,
  SportsGridContentSingleComponent,
  SportsGridHelperComponent,
  SportsGroupComponent,
  SportsLiveNavbarComponent,
} from "@sports-components/index";
import { BehaviorSubject, Observable, Subject, Subscription, of } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { CodereFooterComponent } from "../../../../shared/components/mso/footer/codere-footer/codere-footer";

//Services
import { EventsService } from "@providers/EventsService";
import { NativeService } from "@providers/NativeService";
import { ScriptService } from "@providers/ScriptService";
import { StyleService } from "@providers/StyleService";
import { TrackingService } from "@providers/TrackingService";
import { UrlsService } from "@providers/UrlsService";
import { UserService } from "@providers/UserService";
import { BufferFacade } from "@providers/facades";
import { NewBaseService } from "@providers/newBase.service";
import { WindowRef } from "@providers/window";
import {
  SportBookService,
  SportNavigationService,
  SportService,
  SportsCommonService,
  TicketService,
} from "@sports-services/index";
import { SPORTS_NAVIGATION_SERVICE_ERROR_CODES } from "@sports-services/sports.navigation.service";
import { DeviceService } from "../../../../shared/services/device.service";
import { IonLoaderService } from "../../../../shared/services/loader-feature/ion-loader.service";

//Models
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { C_CategoryInfo, DropdownMode, I_BetSenseModel } from "@sports-models/index";

import { NewTicketFacade, ticketState } from "@sports-features/ticket/stores";
import * as ticketSelector from "@sports-features/ticket/stores/ticket.selectors";
//Stores
import { SportsbookState } from "@sports-stores/sportsbook/index";
import { SportsbookFacade } from "@sports-stores/sportsbook/sportsbook.facade";
import * as sportsbookSelector from "@sports-stores/sportsbook/sportsbook.selectors";

//directives and pipes
import { SportsExtractDatePipe } from "@sports-pipes/index";

//Others
import { SportsBasePage, TrackingInfo } from "@sports-pages/index";
import { SmartLineItem, SmartMarketInput, createSmartLineItem } from "@sports-pages/ticket/models";
import { TicketItemTypesEnum } from "@sports-pages/ticket/utils/ticket.constants";
import { existsIn } from "@sports-services/sports.navigation.service/sports.navigation.utils";
import { SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION } from "@sports-services/sports.navigation.service/sports.navigations.constants";
import { Utils } from "@sports-utils/Utils";
import { SportHandleList, SportsConstants, SportsbookUtils } from "@sports-utils/index";
import { LIVE_MARKET_FILTER_TYPES, SCOREBOARD_TYPE, VIDEOPLAYER_ACTIONS } from "@sports-utils/sports.constants";

export const EXTRA_BUFFER_TIMER = 0;
export const MAX_BUFFER_COUNT = 0;

declare const SIR;
@Component({
  selector: "page-live-market",
  templateUrl: "./live-market.page.html",
  styleUrls: ["./live-market.page.scss"],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    BetbuilderComponent,
    SbDropdownComponent,
    SbGridHeaderComponent,
    SbLiveScoreboardBaseballComponent,
    SbLiveScoreboardRegularComponent,
    SbLiveScoreboardSetsComponent,
    SbMarqueeBetSenseComponent,
    SbTabsCategoriesComponent,
    SportsBetButtonComponent,
    SportsBetButtonWrapperColumnComponent,
    SportsGridComponent,
    SportsGridContentSingleComponent,
    SportsGridHelperComponent,
    SportsGroupComponent,
    SportsLiveNavbarComponent,
    CodereFooterComponent,
  ],
})
export class NowLiveDetailPage extends SportsBasePage implements OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild("scoreboardWidgetSIR") scoreboardWidgetSIR: ElementRef;
  @ViewChild("standardWidgetSIR") standardWidgetSIR: ElementRef;
  @ViewChild("stickyWidgetSIR") stickyWidgetSIR: ElementRef;
  @ViewChild("standardWidgetSIR2") standardWidgetSIR2: ElementRef;
  @ViewChild("stickyWidgetSIR2") stickyWidgetSIR2: ElementRef;

  sisSubject$: Subject<void> = new Subject();
  geniusSubject$: Subject<void> = new Subject();
  watchbetSubject$: Subject<void> = new Subject();
  imgSubject$: Subject<void> = new Subject();
  betradarSubject$: Subject<void> = new Subject();

  breadcrumbs: string[];

  filterTypeSelected$: BehaviorSubject<string> = new BehaviorSubject("");
  //GameType property used for identify "Resultados Finales"
  public gametypes: number[] = [284, 114, 37, 82, 153, 192];
  globalVars: GlobalVarsModel;
  isDesktop = false;
  isFastGamesHidden = true;
  isMobile = false;
  market;
  providerVideo;
  isSrcVideoLoaded = false;

  showingVideo = false;
  sourceSrc;
  streamingSource;
  urlVideoStreaming;
  widgetActive: string;

  LIVE_MARKET_FILTER_TYPES = LIVE_MARKET_FILTER_TYPES;

  _translate = inject(TranslateService);
  newTicketFacade = inject(NewTicketFacade);
  bufferFacade = inject(BufferFacade);
  deviceService = inject(DeviceService);
  modalCtrl = inject(ModalController);
  nativeService = inject(NativeService);
  trackingService = inject(TrackingService);
  renderer = inject(Renderer2);
  route = inject(ActivatedRoute);
  scriptService = inject(ScriptService);
  sportBookService = inject(SportBookService);
  sportService = inject(SportService);
  styleService = inject(StyleService);
  ticketService = inject(TicketService);
  urlsService = inject(UrlsService);
  userService = inject(UserService);
  utils = inject(Utils);
  windowRef = inject(WindowRef);
  newBaseService = inject(NewBaseService);
  eventService = inject(EventsService);
  router = inject(Router);
  sportBookUtils = inject(SportsbookUtils);

  dropdownMode = DropdownMode;
  extractDate = inject(SportsExtractDatePipe);
  locationStrategy = inject(LocationStrategy);

  ionLoaderService = inject(IonLoaderService);

  ticketStore = inject(Store<ticketState>);
  sportsbookStore = inject(Store<SportsbookState>);

  sportsbookFacade = inject(SportsbookFacade);
  sportNavigationService = inject(SportNavigationService);
  sportCommonService = inject(SportsCommonService);

  // Betbuilder
  betbuilderSelection$: Observable<SmartLineItem[]>;
  betbuilderSelection = [];
  smartMarketRequest: SmartMarketInput;
  betbuilderCuotaText: string = "";
  betbuilderMessageText: string = SportsConstants.AnadirAlMenosXSelecciones;
  betbuilderErrorMessage: string = "";

  betbuilderSelectionSub: Subscription;
  betbuilderCatId = SportsConstants.betbuilderCatId;

  // live market
  liveMarketData$: Observable<any>;
  liveMarketDataSub$: Subscription;
  currentCategory$ = new BehaviorSubject(null);
  categories$: Observable<C_CategoryInfo[]>;
  match$: Observable<any>;
  liveMarketBets$;

  // Betsense
  betsenseData = [];
  scoreboardType: string;

  private ngUnsubscribe$ = new Subject<boolean>();

  restoreScrollAndSelectionDone = false;
  stateToSave = {
    selectedCategory: undefined,
  };
  stateToRestore = undefined;
  sportsNavigationId = undefined;

  runVideoFirstLoad = false;
  runVideoFirstLoadDone = false;

  SCOREBOARD_TYPE = SCOREBOARD_TYPE;

  constructor() {
    super();
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe();

    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
    this.market = currentUrl.state.params;
    this.sportsNavigationId = currentUrl.state.sportsNavigationId;

    this.initializePage();
    this.subscribeSub();
  }

  subscribeSub() {
    this.betbuilderSelection$ = this.ticketStore.select(ticketSelector.getBetbuilderSelection);
    this.betbuilderSelectionSub = this.betbuilderSelection$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((betbuilderSelection: any) => {
        this.betbuilderSelection = betbuilderSelection;
        this.checkBetbuilderLength();
      });

    this.liveMarketData$ = this.sportsbookStore.select(sportsbookSelector.getLiveMarketDataState);
    this.liveMarketDataSub$ = this.liveMarketData$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((liveMarketData) => {
        if (!this.market?.LeagueName) this.setBreadcrumbs(liveMarketData.market);

        this.market = liveMarketData.market;
        const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
        if (currentUrl.popstate && !this.restoreScrollAndSelectionDone) {
          this.sportsNavigationId = currentUrl.state.sportsNavigationId;
          this.stateToRestore = this.sportNavigationService.getRestoreStateFromHistory(this.sportsNavigationId);
          if (this.stateToRestore) {
            this.stateToSave = this.stateToRestore;
          }
          if (
            this.stateToRestore?.selectedCategory &&
            existsIn(this.stateToRestore.selectedCategory, liveMarketData.categories, "CategoryId")
          ) {
            this.sportsbookFacade.setLiveMarketSelectedCategory({
              selectedCategory: this.stateToRestore.selectedCategory,
            });
          }

          this.restoreScrollAndSelectionDone = true;
        }

        this.currentCategory$.next(liveMarketData.selectedCategory);
        this.categories$ = of(liveMarketData.categories);
        this.liveMarketBets$ = liveMarketData?.currentLiveMarketData?.Event;
        if (liveMarketData?.currentLiveMarketData?.Event) {
          this.match$ = of(liveMarketData.currentLiveMarketData.Event.liveData);
          if (this.runVideoFirstLoad) {
            this.runVideoFirstLoad = false;
            this.switchVideo();
          }
        }
        this.scoreboardType = liveMarketData?.currentLiveMarketData?.Event?.detailScoreboard;
        if (liveMarketData.betsenseData) {
          this.betsenseData = this.setBetSenseData(liveMarketData.betsenseData);
        }
      });
  }

  trackBy(index, item) {
    return item.NodeId;
  }

  sendAddSmartMarketItem() {
    const smartMarketBet = createSmartLineItem(this.betbuilderSelection, this.market, this.betbuilderCuotaText);
    delete this.smartMarketRequest["MaxSystem"];
    this.newTicketFacade.sendAddSmartMarketItem(this.smartMarketRequest, smartMarketBet);
  }

  close() {
    this.sportNavigationService.back();
  }

  betSenseBet(NodeId) {
    this.sportService.getGameByNodeId(NodeId).subscribe((data) => {
      if (data) {
        const bet = this.sportBookUtils.transformGameDataForBet(data);
        this.bet(bet.betItem, bet.gameGroup, bet.name, SportsConstants.BETSENSE);
      } else {
        this.utils.sportsAlert(true, "", "Mercado no disponible", this._translate.instant("tAccept"));
      }
    });
  }

  bet(game: any, event: any, gameName: string, type: string, position: string = "") {
    const data = {
      ...game,
      EventDate: this.extractDate.transform(event.StartDate),
      EventName: event.Name,
      GameName: gameName,
    };

    this.correctData(data, event, gameName, type, position);

    if (this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId) {
      this.checkBetbuilderSelection(data, data.NodeId, game.GameTypeId);
    } else {
      this.newTicketFacade.checkSelection(data, data.NodeId, TicketItemTypesEnum.LINE_ITEM);
    }
  }

  checkSelected(nodeId) {
    let selected = false;
    if (this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId) {
      selected = this.betbuilderSelectionCheck(nodeId);
    } else {
      selected = this.newTicketFacade.hasResult(nodeId);
    }
    return selected;
  }

  getPosition(length: number, index: number) {
    let position = "";
    if (length > 2) {
      switch (true) {
        case index === 1:
          position = "X";
          break;
        case index === 2:
          position = "2";
          break;
        default:
          position = "1";
          break;
      }
    } else {
      switch (true) {
        case index === 1:
          position = "2";
          break;
        default:
          position = "1";
          break;
      }
    }
    return position;
  }

  onScroll(event) {
    if (!this.showSportRadar() || this.filterTypeSelected$.value !== LIVE_MARKET_FILTER_TYPES.SPORTRADAR) {
      return;
    }
    if (event.detail.scrollTop > 0) {
      this.widgetActive = "sticky";
      this.renderer.addClass(this.standardWidgetSIR.nativeElement, "d-none");
      this.renderer.removeClass(this.stickyWidgetSIR.nativeElement, "d-none");
    } else {
      this.widgetActive = "standard";
      this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
      this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
    }
  }

  public filterTypeSelected(filterType: string) {
    return filterType === this.filterTypeSelected$.value;
  }

  public hideFilterType(filterType: string) {
    if (this.market !== undefined) {
      switch (filterType) {
        case LIVE_MARKET_FILTER_TYPES.SPORTRADAR:
          return !this.showSportRadar();
        case LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING:
          return !this.market.StreamingEnabled;
        case LIVE_MARKET_FILTER_TYPES.SCOREBOARD:
          return (!this.market.StreamingEnabled && !this.showSportRadar()) || !this.scoreboardType;
      }
    } else {
      return true;
    }
  }

  switchVideo() {
    const originalHeight = this.isDesktop
      ? document.getElementsByClassName("sb-grid-layout")[0].getBoundingClientRect().height
      : 0;
    if (this.globalVars.user.logged && this.market.StreamingEnabled) {
      this.showingVideo = !this.showingVideo;
      this.filterTypeSelected$.next(LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING);
      if (this.showingVideo) {
        if (this.showSportRadar() && this.isMobile) {
          this.renderer.addClass(this.scoreboardWidgetSIR.nativeElement, "d-none");
          this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
          this.renderer.addClass(this.standardWidgetSIR.nativeElement, "d-none");
        }
        Promise.all([
          this.scriptService.load("betradarliveplayer"),
          this.styleService.load("betradarliveplayer"),
        ]).then(() => {
          switch (this.market.StreamingEnabled) {
            case "watchbet":
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
              });
              break;
            case "betradar":
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
                height: originalHeight,
              });
              break;
            case "sis":
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
              });
              break;
            case "genius":
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
              });
              break;
            case "img": // done
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
              });
              break;
            case "beter":
              this.eventService.publish(VIDEOPLAYER_ACTIONS.RUN, {
                event: this.market,
              });
              break;
            default:
              break;
          }
          this.globalVars.videoPlayerWindow = false;
        });
      } else {
        this.eventService.publish(VIDEOPLAYER_ACTIONS.CLOSE);
      }
    } else if (!this.globalVars.user.logged) {
      this.globalVars.afterLoginUrl = null;
      this.nativeService.checkTouchId();
    }
  }

  changeFilter(filter) {
    if (filter.CategoryId !== SportsConstants.FastbetCategoryId) {
      this.isFastGamesHidden = true;
    } else {
      this.isFastGamesHidden = false;
    }

    this.sportsbookFacade.setLiveMarketSelectedCategory({
      selectedCategory: filter,
    });
    this.stateToSave = {
      ...this.stateToSave,
      selectedCategory: filter,
    };
    this.content?.scrollToTop();
  }

  correctData(data: any, event: any, gameName: string, type: string, position: string) {
    switch (true) {
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "1":
        data.Name = `${this.market.teamHome} ${data.Name}`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "X":
        data.Name = `X (${this.market.teamAway} ${data.Name})`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "2":
        data.Name = `${this.market.teamAway} ${data.Name}`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "10" && position === "1":
        data.Name = `${this.market.teamHome} ${data.Name}`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "10" && position === "X":
        data.Name = `X (${this.market.teamAway} ${data.Name})`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "10" && position === "2":
        data.Name = `${this.market.teamAway} ${data.Name}`;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "0":
        data.GameName = SportsConstants.FirstGoalscorerLiteral;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "1":
        data.GameName = SportsConstants.ScoreGoalDuringTheMatch;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "2":
        data.GameName = SportsConstants.ScoreTwoOrMoreGoalsLiteral;
        break;
    }
    return data;
  }

  checkBetbuilderSelection(data, nodeId, gameTypeId) {
    const id = this.betbuilderSelection.findIndex((item) => item.NodeId === nodeId);
    // remove
    if (id !== -1) {
      this.newTicketFacade.removeSmartMarketSelection(nodeId);
    } else {
      //add
      this.newTicketFacade.sendAddSmartMarketSelection(data);
    }
  }

  betbuilderSelectionCheck(nodeId) {
    const nodeSelected = this.betbuilderSelection.filter((item) => item.NodeId === nodeId).length > 0;
    let selected = false;
    selected = this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId && nodeSelected;

    return selected;
  }

  checkBetbuilderLength() {
    try {
      switch (this.betbuilderSelection.length) {
        case 0:
          // 'Necesitas al menos 2 selecciones.';
          this.betbuilderMessageText = SportsConstants.SPO_BetbuilderMessage2;
          this.betbuilderCleanValues();
          break;
        case 1:
          // 'Añadir al menos 1 o más selecciones.';
          this.betbuilderMessageText = SportsConstants.SPO_BetbuilderMessage1;
          this.betbuilderCleanValues();
          break;
        default:
          // 'Apostar o añadir más selecciones';
          this.betbuilderMessageText = SportsConstants.SPO_BetbuilderMessage;
          this.betbuilderCheck();
          break;
      }
    } catch (e) {
      console.log("Error checking Betbuilder Length");
      this.sportsbookFacade.setSportsError({
        errorCode: SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR,
        errorDescription: SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION.LOCATION_11,
      });
    }
  }

  betbuilderCleanValues() {
    this.betbuilderCuotaText = "";
    this.betbuilderErrorMessage = "";
  }

  betbuilderCheck() {
    this.ionLoaderService.showHideAutoLoader();
    this.sportService.addSmartMarketItem(this.betbuilderSelection).subscribe((resp) => {
      this.ionLoaderService.hideLoader();
      if (resp?.Odds < 0) {
        this.betbuilderCuotaText = "";
        // 'Combinación no válida. Algunas de tus selecciones no son combinables. Por favor, cámbialas para continuar.';
        this.betbuilderErrorMessage = SportsConstants.SPO_BetbuilderMessageError;
        this.smartMarketRequest = null;
      } else {
        this.betbuilderCuotaText = resp.Odds.toFixed(2).toString();
        this.betbuilderErrorMessage = "";
        this.smartMarketRequest = resp;
      }
    });
  }

  setBetSenseData(betSenseData) {
    const betsenseItems: I_BetSenseModel[] = [];
    betSenseData.forEach((betSenseDataItem) => {
      const NodeId = betSenseDataItem.outcomes.find(
        (item) => item.label === betSenseDataItem.delivery.es.log.cta_target,
      ).id;

      betsenseItems.push({
        title: betSenseDataItem.delivery?.es?.log?.body,
        Name: betSenseDataItem.delivery?.es?.log?.cta,
        Odd: betSenseDataItem.data.offer.outcomes.find((i) => i.id === NodeId).oddsDecimal,
        marketName: betSenseDataItem.data?.offer?.name,
        NodeId,
      });
    });
    return betsenseItems.filter((item, index, self) => index === self.findIndex((t) => t.NodeId === item.NodeId));
  }

  initializePage() {
    this.globalVars.hideBetFooterBar = false;
    this.trackingService.trackEvent([
      "SelectEventLive",
      this.market.NodeId,
      this.market.SportHandle,
      this.market.Name,
      "pageView",
    ]);
    this.subscribeVideoLive();
    this.sportsbookFacade.initLiveMarket({
      market: this.market,
      isBetsenseEnable: this.globalVars.FEATURES.SPO_betsenseLiveEnabled,
    });
  }

  ngAfterViewInit() {
    this.showScoreboards();
  }

  private subscribeVideoLive() {
    this.eventService.subscribe(VIDEOPLAYER_ACTIONS.CLOSE, () => {
      if (this.isMobile && this.filterTypeSelected$.value === LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING) {
        this.setFilterType(
          this.showSportRadar() ? LIVE_MARKET_FILTER_TYPES.SPORTRADAR : LIVE_MARKET_FILTER_TYPES.SCOREBOARD,
        );
      }
      this.showingVideo = false;
      this.content?.scrollToTop();
    });
    this.eventService.subscribe(VIDEOPLAYER_ACTIONS.TO_TICKET, () => {
      if (this.globalVars.videoPlayerWindow && this.showingVideo) {
        this.showingVideo = false;
      }
    });
  }

  private showSportRadar() {
    if (this.market) {
      return (
        (this.market.SportHandle === SportHandleList.soccer ||
          this.market.SportHandle === SportHandleList.tennis ||
          this.market.SportHandle === SportHandleList.basketball ||
          this.market.SportHandle === SportHandleList.motorsport) &&
        this.market.LTMEnabled
      );
    } else {
      return false;
    }
  }

  setFilterType(filterType: string) {
    if (filterType === this.filterTypeSelected$.value) {
      return;
    }
    switch (filterType) {
      case LIVE_MARKET_FILTER_TYPES.SPORTRADAR:
        this.widgetActive = "standard";
        this.filterTypeSelected$.next(filterType);
        if (this.showingVideo) this.eventService.publish(VIDEOPLAYER_ACTIONS.CLOSE);
        this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
        this.renderer.removeClass(this.scoreboardWidgetSIR.nativeElement, "d-none");
        this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
        break;
      case LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING:
        this.switchVideo();
        break;
      case LIVE_MARKET_FILTER_TYPES.SCOREBOARD:
        this.filterTypeSelected$.next(filterType);
        this.eventService.publish(VIDEOPLAYER_ACTIONS.CLOSE);
        this.renderer.addClass(this.scoreboardWidgetSIR.nativeElement, "d-none");
        this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
        this.renderer.addClass(this.standardWidgetSIR.nativeElement, "d-none");
        break;
    }
  }

  showScoreboards() {
    if (this.showSportRadar()) {
      if (this.market.SportHandle !== SportHandleList.motorsport) {
        Promise.all([
          this.scriptService.load(LIVE_MARKET_FILTER_TYPES.SPORTRADAR),
          this.styleService.load(LIVE_MARKET_FILTER_TYPES.SPORTRADAR),
        ]).then(() => {
          this.sportService.showSportradar$.next(true);
          this.sportService.eventStatisticsId$.next(this.market.StatisticsId);
          this.sportService.isFormula1$.next(false);
          if (this.isMobile) {
            this.filterTypeSelected$.next(LIVE_MARKET_FILTER_TYPES.SPORTRADAR);
            this.widgetActive = "standard";
            this.setSportRadarWidget();
          }
        });
      }
      if (this.showFormula1()) {
        Promise.all([
          this.scriptService.load(LIVE_MARKET_FILTER_TYPES.SPORTRADAR_F1),
          this.styleService.load(LIVE_MARKET_FILTER_TYPES.SPORTRADAR),
        ]).then(() => {
          this.sportService.showSportradar$.next(true);
          this.sportService.eventStatisticsId$.next(this.market.StatisticsId);
          this.sportService.isFormula1$.next(true);
          if (this.isMobile) {
            this.widgetActive = "standard";
            this.setSportRadarWidgetF1();
          }
        });
      }
    } else {
      this.filterTypeSelected$.next(LIVE_MARKET_FILTER_TYPES.SCOREBOARD);
    }

    this.setBreadcrumbs(this.market);

    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;

    if (currentUrl.state?.queryParams?.openVideo && !this.runVideoFirstLoadDone) {
      this.runVideoFirstLoadDone = true;
      this.runVideoFirstLoad = true;
      this.eventService.publish(VIDEOPLAYER_ACTIONS.CLOSE);
    }
  }

  private setBreadcrumbs(market) {
    const sportName = market.SportName;
    this.breadcrumbs = [sportName, market.LeagueName];
  }

  private setSportRadarWidget() {
    this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
    SIR(
      "addWidget",
      ".sr-widget-3",
      "match.lmtPlus",
      {
        layout: "topdown",
        scoreboard: "compact",
        detailedScoreboard: "disable",
        tabsPosition: "disable",
        dbgData: null,
        disablePitch: true,
        disablePitchClock: null,
        disableComponents: true,
        matchId: this.market.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content?.scrollToTop();
        }, 500),
    );
    SIR(
      "addWidget",
      ".sr-widget-1",
      "match.lmtSticky",
      {
        layout: "topdown",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        matchId: this.market.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content?.scrollToTop();
        }, 500),
    );
    SIR(
      "addWidget",
      ".sr-widget-2",
      "match.lmtPlus",
      {
        layout: "single",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        pitchLogo: "./assets/global/img/codere-apuestas-mx.svg",
        goalBannerImage: "./assets/global/img/codere_green.svg",
        logo: ["./assets/global/img/codere_grey.svg"],
        matchId: this.market.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content?.scrollToTop();
        }, 500),
    );
    this.renderer.listen(this.stickyWidgetSIR.nativeElement, "click", () => {
      this.widgetActive = "standard";
      this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
      this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
    });
  }

  setSportRadarWidgetF1() {
    this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
    SIR(
      "addWidget",
      ".sr-widget-1",
      "match.lmtSticky",
      {
        layout: "topdown",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        stageId: this.market.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );
    SIR(
      "addWidget",
      ".sr-widget-2",
      "match.lmtPlus",
      {
        layout: "single",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        pitchLogo: "./assets/global/img/codere-apuestas-mx.svg",
        goalBannerImage: "./assets/global/img/codere_green.svg",
        logo: ["./assets/global/img/codere_grey.svg"],
        stageId: this.market.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );
    this.renderer.listen(this.stickyWidgetSIR2.nativeElement, "click", () => {
      this.widgetActive = "standard";
      this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
      this.renderer.removeClass(this.standardWidgetSIR2.nativeElement, "d-none");
    });
  }

  public showFormula1() {
    const showF1 =
      this.globalVars?.FEATURES.SPO_LMTFormula1 &&
      this.market.SportHandle === SportHandleList.motorsport &&
      !!this.market.StatisticsId;
    return showF1;
  }

  removeSmartMarketSelections() {
    this.newTicketFacade.clearBetbuilderSelections();
  }

  getTrackingInfo(): TrackingInfo {
    return {
      uri: encodeURI(`/${this.market.SportHandle}/${this.market.LeagueName}/live/${this.market.Name}`),
      description: `NowLiveDetail page - ${this.market.Name}`,
      additionalData: {
        nodeId: this.market.NodeId,
        sportHandle: this.market.SportHandle,
        leagueName: this.market.LeagueName,
      },
    };
  }

  unsuscribeToSubjects() {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
    this.sisSubject$.next();
    this.sisSubject$.complete();
    this.geniusSubject$.next();
    this.geniusSubject$.complete();
    this.watchbetSubject$.next();
    this.watchbetSubject$.complete();
    this.imgSubject$.next();
    this.imgSubject$.complete();
    this.betradarSubject$.next();
    this.betradarSubject$.complete();
  }

  ngOnDestroy() {
    this.unsuscribeToSubjects();
    if (this.showSportRadar() && this.isMobile) {
      SIR("removeWidget", document.querySelector(".sr-widget-1"));
      SIR("removeWidget", document.querySelector(".sr-widget-2"));
      SIR("removeWidget", document.querySelector(".sr-widget-3"));
    } else if (this.showSportRadar() && this.isDesktop) {
      this.sportService.showSportradar$.next(false);
      this.sportService.eventStatisticsId$.next("");
      this.sportService.isFormula1$.next(false);
    }
    this.removeSmartMarketSelections();

    if (this.globalVars.FEATURES.SPO_LMTFormula1 && this.showFormula1()) {
      this.sportService.showSportradar$.next(false);
      this.sportService.eventStatisticsId$.next("");
      this.sportService.isFormula1$.next(false);
    }

    this.sportNavigationService.injectLastStateToHistory(this.sportsNavigationId, this.stateToSave);
  }
}
